var React = require('react');

function ArrowLNavy (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Side","d":"M0,3.718,3.718,0,7.437,3.718","transform":"translate(4.072 0.354) rotate(90)","fill":"none","stroke":"#022137","strokeWidth":"1"}));
}

ArrowLNavy.defaultProps = {"width":"4.779","height":"8.144","viewBox":"0 0 4.779 8.144"};

module.exports = ArrowLNavy;

ArrowLNavy.default = ArrowLNavy;
